import { render, staticRenderFns } from "./AppLauncher.vue?vue&type=template&id=b6606f8a&"
import script from "./AppLauncher.vue?vue&type=script&lang=js&"
export * from "./AppLauncher.vue?vue&type=script&lang=js&"
import style0 from "./AppLauncher.vue?vue&type=style&index=0&id=b6606f8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports